import { getAppApiRoutes } from "../../Global";
import { DeliveryAddressAddRequestModel, DeliveryAddressUpdateRequestModel } from "../../models/RequestModels";
import ResponseModel from "../../models/ResponseModel";
import { apiDelete, apiGet, apiPost, apiPut } from "../apiClient";

class DeliveryAddressService {
  async deleteDeliveryAddress(id: number): Promise<ResponseModel> {
    return apiDelete(getAppApiRoutes.deliveryAddress.removeDeliveryAddress.replace("{id}", id.toString()));
  }

  async updateDeliveryAddress(deliveryAddress: DeliveryAddressUpdateRequestModel, id: string): Promise<ResponseModel> {
    return apiPut(getAppApiRoutes.deliveryAddress.updateDeliveryAddress.replace("{id}", id), { ...deliveryAddress });
  }

  async addDeliveryAddress(deliveryAddress: DeliveryAddressAddRequestModel): Promise<ResponseModel> {
    return apiPost(getAppApiRoutes.deliveryAddress.addDeliveryAddress, deliveryAddress);
  }

  async getDeliveryAddress(id: string): Promise<ResponseModel> {
    return apiGet(getAppApiRoutes.deliveryAddress.getDeliveryAddress.replace("{id}", id));
  }
}

const service: DeliveryAddressService = new DeliveryAddressService();
export default service;
